<template>
    <div>
        <div v-if="currentLogin && !isLoggedIn">
            <div class="flex gap-1" v-if="template === 1">
                <div> {{ currentLogin?.name }}</div>
                <button class="btn btn-primary btn-xs" @click="fetchCustomToken(currentLogin?.token)">Giriş Yap</button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import store from '../../store';
import useFirebaseAuth from "../../compositions/useFirebaseAuth";
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../../services/firebase';


const props = defineProps({
    template: {
        type: Number,
        default: 1
    }   
})

const { 
  user,
  isLoggedIn,
  logout
} = useFirebaseAuth();


const currentLogin = computed(() => {
  return store.getters._getLogin;
});


async function fetchCustomToken(token) {
  try {
    let url = import.meta.env.VITE_FIREBASE_FUNCTION_URL;
    const response = await fetch(url + 'createCustomTokenFromIdTokenHttp', {  method: 'POST',
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      },
      body: JSON.stringify({
        additionalClaims: { role: 3 }
      })
    });
    
    const data = await response.json();
    const user = await signInWithCustomToken(auth, data.token);
    if (data.error) {
      store.commit('setLogin', null);
      throw new Error(data.error);
    }
    
    return data.token;
  } catch (error) {
    store.commit('setLogin', null);
    console.error('Token alma hatası:', error);
    throw error;
  }
}





</script>